import { getRuntimeConfig } from "src/utils/runtime-config";

export interface IQueryParams {
    w?: number;
    h?: number;
    fit?: "clamp" | "clip" | "crop" | "facearea" | "fill" | "fillmax" | "max" | "min" | "scale";
    dpr?: number;
    auto?: string;
}

const DEFAULT_QUERY_PARAMS: IQueryParams = {
    dpr: 2,
    auto: "format",
};

function buildQueryString(_queryParams?: IQueryParams) {
    const queryParams = Object.assign({}, DEFAULT_QUERY_PARAMS, _queryParams);
    const queryString = Object.keys(queryParams)
        .map(key => {
            const val = queryParams[key as keyof IQueryParams];
            if (Boolean(val)) {
                return `${key}=${val}`;
            } else {
                return null;
            }
        })
        .filter(Boolean)
        .join("&");

    return queryString ? `${queryString}` : "";
}

export function buildUrl(baseUrl?: string, _queryParams?: IQueryParams): string {
    if (!baseUrl) {
        return "";
    }

    const separator = baseUrl.includes("?") ? "&" : "?";
    return `${baseUrl}${separator}${buildQueryString(_queryParams)}`;
}

export function getImageBaseUrl(): string {
    const { imgixUrl, cloudBlobEnvironmentShortName } = getRuntimeConfig();
    return `${imgixUrl.endsWith("/") ? imgixUrl : imgixUrl + "/"}${cloudBlobEnvironmentShortName}/`;
}
